import { StoreRootState } from '@/store';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Navigate, Outlet, useNavigate, useParams } from 'react-router-dom';

const RegisterAuth = () => {
	const params = useParams();
	const navigate = useNavigate();
	const { attendee, eventId } = useSelector((state: StoreRootState) => state.registration);
	useEffect(() => {
		if (!attendee) navigate(`/events/${eventId || params.eventId}/register`);
	}, [attendee]);
	return <Outlet />;
};

export default RegisterAuth;
